import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';
import {spacing} from '../constants';

type ContentType = 'privacy' | 'terms';

interface LegalContentProps {
  type: ContentType;
}

export default function LegalContent({type}: LegalContentProps) {
  const {t} = useTranslation();

  if (type === 'privacy') {
    return (
      <>
        <Text style={styles.intro}>{t('home.privacy.intro')}</Text>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.responsible.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.responsible.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.general.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.general.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.hosting.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.hosting.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.data.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.data.content')}
          </Text>

          <Text style={styles.subsectionTitle}>
            {t('home.privacy.sections.data.googleAccount.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.data.googleAccount.content')}
          </Text>

          <Text style={styles.subsectionTitle}>
            {t('home.privacy.sections.data.futureServices.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.data.futureServices.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.purpose.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.purpose.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.storage.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.storage.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.photoCache.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.photoCache.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.security.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.security.content')}
          </Text>

          <Text style={styles.subsectionTitle}>
            {t('home.privacy.sections.security.encryption.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.security.encryption.content')}
          </Text>

          <Text style={styles.subsectionTitle}>
            {t('home.privacy.sections.security.access.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.security.access.content')}
          </Text>

          <Text style={styles.subsectionTitle}>
            {t('home.privacy.sections.security.retention.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.security.retention.content')}
          </Text>

          <Text style={styles.subsectionTitle}>
            {t('home.privacy.sections.security.deletion.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.security.deletion.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.advertising.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.advertising.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.rights.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.rights.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.changes.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.changes.content')}
          </Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.sectionTitle}>
            {t('home.privacy.sections.googleCompliance.title')}
          </Text>
          <Text style={styles.text}>
            {t('home.privacy.sections.googleCompliance.content')}
          </Text>
        </View>
      </>
    );
  }

  // Terms content
  return (
    <>
      <Text style={styles.intro}>{t('home.terms.intro')}</Text>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.provider.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.provider.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.scope.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.scope.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.services.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.services.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.account.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.account.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.thirdParty.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.thirdParty.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.intellectualProperty.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.intellectualProperty.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.userContent.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.userContent.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.availability.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.availability.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.liability.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.liability.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.termination.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.termination.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.changes.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.changes.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.law.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.law.content')}
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {t('home.terms.sections.contact.title')}
        </Text>
        <Text style={styles.text}>
          {t('home.terms.sections.contact.content')}
        </Text>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  section: {
    marginBottom: spacing.lg,
  },
  sectionTitle: {
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    fontSize: 16,
    fontWeight: '700',
    color: '#221910',
    marginBottom: spacing.sm,
  },
  subsectionTitle: {
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    fontSize: 14,
    fontWeight: '600',
    color: '#221910',
    marginTop: spacing.md,
    marginBottom: spacing.xs,
  },
  intro: {
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    fontSize: 15,
    fontWeight: '400',
    color: '#444',
    lineHeight: 22,
    marginBottom: spacing.lg,
  },
  text: {
    fontFamily: 'Plus Jakarta Sans, sans-serif',
    fontSize: 14,
    fontWeight: '400',
    color: '#666',
    lineHeight: 20,
  },
});
